import React, {useCallback, useEffect, useMemo, useState} from 'react';
import {
    MaterialReactTable,
    MRT_GlobalFilterTextField,
    MRT_ToggleFiltersButton,
    MRT_ToolbarAlertBanner
} from 'material-react-table';
import {MRT_Localization_RU} from "material-react-table/locales/ru";
import Box from "@mui/material/Box";
import {Button, Checkbox, Stack, Tooltip, Typography} from "@mui/material";
import {Link, useNavigate} from "react-router-dom";
import {materialReserveState} from "../../../../../data/MaterialReserveState";
import DateTimeUtil from "../../../../../utils/common/DateTimeUtil";
import DateRangeFilter from "../../../filter/DateRangeFilter";
import CellMaterialEstimateUnitTypePrice from "../../orders/organization/estimate/CellMaterialReserveTypePrice";
import MaterialReserveUtil from "../../../../../utils/warehouse/MaterialReserveUtil";
import CellCheckbox from "../../../сheckbox/CellCheckbox";
import FilterUtil from "../../../../../utils/common/FilterUtil";
import ModalConfirm from "../../../modal/ModalConfirm";
import MaterialReserveService from "../../../../../API/orders/reservation/MaterialReserveService";
import UnitService from "../../../../../API/orders/warehouse/UnitService";
import Common from "../../../../../utils/common/Common";
import {CreateSlabMaterialModal} from "./CreateSlabMaterialModal";
import CellMaterialEstimateBasePrice from "./CellMaterialEstimateBasePrice";
import ButtonCreate from "../../../button/ButtonCreate";
import MenuItem from "@mui/material/MenuItem";
import {materialEstimateUnitStates} from "../../../../../data/MaterialEstimateUnitState";
import NameModal from "../../../modal/NameModal";
import selectionTableUtil, {normalizeSelection} from "../../../../../utils/common/SelectionTableUtil";

const ReservationMaterialEstimateUnitTable = ({
                                                  data,
                                                  setData,
                                                  isColumnMaterialWarehouse,
                                                  isSlab,
                                                  orderId,
                                                  orderHeaderId,
                                                  nameOrder,
                                                  isButtonPurchase,
                                                  estimateId,
                                                  year,
                                                  isIssue,
                                                  unablePackaging,
                                                  setUnablePackaging,
                                                  isLinear,
                                                  enableEditing,
                                                  packaging,
                                                  showSetOnIssue,
                                                  materialEstimateUnitId,
                                                  tableOptions,
                                                  tableOptionsHandle,
                                                  handleModalAlert,
                                                  status,
                                                  isPackaging,
                                                  enableRowSelection,
                                                  rowSelection,
                                                  setRowSelection,
                                                  isPieceMaterials,
                                                  isReserveWareHouse,
                                                  isColumnOrder,
                                                  isReserveArrival,
                                                  typeMaterial,
                                                  nameMaterial,
                                                  baseUnit,
                                                  isArrival,
                                                  materialId,
                                                  materialWarehouseId,
                                                  id,
                                                  estimateState,
                                                  articleNumber,
                                                  isEstimate,
                                                  type,
                                                  arrivalMaterialId,
                                                  arrivalMaterial,
                                                  currentCurrency,
                                                  supplierId,
                                                  warehouseId,
                                                  isIssuingEdge,
                                                  issuingNumber
                                              }) => {

    const allCalculation = MaterialReserveUtil.checkOrAllCalculation(data);

    const profile = JSON.parse(localStorage.getItem("profile"))
    const [baseCurrency, setBaseCurrency] = useState(profile?.baseCurAbbreviation);
    const [alternativeCurrency, setAlternativeCurrency] = useState(profile?.alternativeCurAbbreviation);

    const [openModal, setOpenModal] = useState(false);
    const [issuedModal, setIssuedModal] = useState(false);
    const [returnModal, setReturnModal] = useState(false);
    const [currentId, setCurrentId] = useState(null);
    const [currentEditRow, setCurrentEditRow] = useState(null);
    const currentIsSlab = isSlab === 'true'
    const currentPackaging = !isSlab && !isLinear && packaging
    const [createModalOpen, setCreateModalOpen] = useState(false);

    const [modalNote, setModalNote] = useState(false);
    const [modalDivide, setModalDivide] = useState(false);
    const [currentEditRowData, setCurrentEditRowData] = useState(null);
    const [loading, setLoading] = useState(false)

    const sumAmountAlternativePrice = useMemo(
        () => data.reduce((acc, mR) => acc + mR.amountAlternativePrice, 0),
        [data]
    );

    const sumAmountBasePrice = useMemo(
        () => data.reduce((acc, mR) => acc + mR.amountBasePrice, 0),
        [data]
    );

    const sumAmountQuantity = useMemo(
        () => data.reduce((acc, mR) => acc + mR.quantity, 0),
        [data]
    );

    const sumIssued = useMemo(
        () => data.reduce((acc, mR) => acc + mR.issued, 0),
        [data]
    );

    const navigate = useNavigate();

    const {onRowSelectionChange} = selectionTableUtil(data, setRowSelection)
    const currentSelection = normalizeSelection(rowSelection)

    const handleCloseSetPurchase = () => {
        setCurrentId(null);
        setCurrentEditRow(null);
        setOpenModal(false);
        setIssuedModal(false)
        setReturnModal(false)
    };

    const handleSubmitSetPurchase = async () => {
        MaterialReserveService.issue(currentId,)
            .then(function (response) {
                let dataR = response.data;
                Common.handleUpdate(currentEditRow, dataR, data, setData)
                handleModalAlert("Выдача подтверждена", 'success')
                handleCloseSetPurchase()
            })
            .catch(function (error) {
                handleModalAlert(error);
            })
    }
    const handleSetIssued = async () => {
        MaterialReserveService.setIssued(currentId)
            .then(function (response) {
                setData(prev => prev.map(el => el.id === currentId ? {...el, materialReserveState: "ISSUED"} : el))
                handleModalAlert("Помечен как выданный", 'success')
                handleCloseSetPurchase()
            })
            .catch(function (error) {
                handleModalAlert(error);
            })
    }
    const handleSubmitReturn = () => {
        console.log(currentId)
        MaterialReserveService.return(currentId)
            .then(function (response) {
                setData(prev => prev.map(el => el.id === currentId ? {
                    ...el,
                    materialReserveState: "IN_STOCK",
                    issued: 0
                } : el))
                handleModalAlert("Резерв возвращён", 'success')
                handleCloseSetPurchase()
            })
            .catch(function (error) {
                handleModalAlert(error);
            })
    }

    const handleSaveRowEdits = async ({exitEditingMode, row, values}) => {
        UnitService.update(values)
            .then(function () {
                data[row.index] = values;
                setData([...data]);
                handleModalAlert("Данные изменены", 'success')
            })
            .catch(function (error) {
                handleModalAlert(error);
            })
        exitEditingMode();
    };


    const setOnIssue = (row) => {
        const id = row.id;
        setCurrentId(id);
        setOpenModal(true);
        setCurrentEditRow(row);
    }

    const setOnIssued = (row) => {
        const id = row.id;
        setCurrentId(id);
        setIssuedModal(true);
        setCurrentEditRow(row);
    }

    const setReturn = (row) => {
        const id = row.id;
        setCurrentId(id);
        setReturnModal(true);
        setCurrentEditRow(row);
    }

    const handleEditNote = (row) => {
        setModalNote(true)
        setCurrentEditRowData(row)
    }
    const handleClose = () => {
        setModalNote(false)
        setModalDivide(false)
        setCurrentEditRowData(null)
    }
    const handleUpdateNote = (data) => {
        setLoading(true)
        MaterialReserveService.editNote(currentEditRowData.id, data.name)
            .then(function () {
                setData(prev => prev.map(el => el.id === currentEditRowData.id ? {...el, note: data.name} : el));
                handleModalAlert("Заметка изменена", 'success')
            })
            .catch(function (error) {
                handleModalAlert(error);
            })
            .finally(() => setLoading(false))
    }

    const handleDeleteRow = useCallback(
        (row) => {
            MaterialReserveService.delete(row.id)
                .then(function () {
                    setData(prev => prev.filter(el => el.id !== row.id));
                    handleModalAlert("Данные удалены", 'success')
                })
                .catch(function (error) {
                    handleModalAlert(error);
                })
        },
        [data],
    );

    const handleDivide = (row) => {
        setModalDivide(true)
        setCurrentEditRowData(row)
    }
    const divideReserve = (data) => {
        setLoading(true)
        MaterialReserveService.divide(currentEditRowData.id, data.name)
            .then(function () {
                // setData(prev => prev.filter(el => el.id !== row.id));
                handleModalAlert("Резервы разделены", 'success')
            })
            .catch(function (error) {
                handleModalAlert(error);
            })
            .finally(() => setLoading(false))
    }
    const handleDeleteArrival = (row) => {
        MaterialReserveService.delete(row.id)
            .then(function () {
                setData(prev => prev.filter(el => el.id !== row.id));
                handleModalAlert("Удалено из закупки", 'success')
            })
            .catch(function (error) {
                handleModalAlert(error);
            })
    }
    const handleSetPurchase = (row) => {
        MaterialReserveService.setPurchase(row.id)
            .then(function () {
                setData(prev => prev.map(el => el.id === row.id ? {
                    ...el,
                    materialReserveState: "WAITING_FOR_AN_APPLICATION"
                } : el))
                handleModalAlert("Отправлено на закупку", 'success')
            })
            .catch(function (error) {
                handleModalAlert(error);
            })
    }
    const handlePackaging = (row) => {
        MaterialReserveService.setPackaging(row.id, !row.packaging)
            .then(function () {
                setData(prev => prev.map(el => el.id === row.id ? {
                    ...el,
                    packaging: !row.packaging
                } : el))
                handleModalAlert("Данные изменены", 'success')
            })
            .catch(function (error) {
                handleModalAlert(error);
            })
    }

    const handleCreateNewRow = (values) => {
        data.push(values);
        setData([...data]);
    };

    const columns = useMemo(() => {
        const baseColumns = [
            {
                id: 'quantity',
                header: 'Необходимо.',
                accessorKey: 'quantity',
                minSize: 15,
                maxSize: 15,
                Cell: ({cell, row}) => {
                    const value = cell.getValue();
                    return value === null || value === undefined ? 'Ожидание' : value.toFixed(3)
                },
                Footer: () => (
                    <Stack>
                        <Box color="warning.main">
                            {sumAmountQuantity?.toLocaleString?.('en-US', {
                                minimumFractionDigits: 0,
                                maximumFractionDigits: 3,
                            })}
                        </Box>
                    </Stack>
                ),
            },
            {
                id: 'materialReserveState',
                header: 'Статус',
                accessorKey: 'materialReserveState',
                maxSize: 130,
                Cell: ({cell, row}) => {
                    const value = cell.getValue();
                    const path =
                        isIssuingEdge ?
                            '/organization/materials-price-unit-arrival-item/reserve-issuingEdge/' + materialWarehouseId + '/' + typeMaterial + '/' + baseUnit + "/" + id + "/" + issuingNumber + "/" + false :
                            isReserveArrival ?
                                '/organization/materials-price-unit-arrival-item/reserve-arrival/' + row.original.materialWarehouse?.materialPriceUnit.id + "/" + arrivalMaterialId + '/' + encodeURIComponent(arrivalMaterial) + '/' + currentCurrency + '/' + supplierId + '/' + warehouseId + "/" + id + "/" + typeMaterial + "/" + baseUnit + "/" + false :
                                isReserveWareHouse ?
                                    '/organization/materials-price-unit-arrival-item/reserve-warehouse/' + materialWarehouseId + '/' + typeMaterial + '/' + baseUnit + '/' + id + '/' + materialId + '/' + encodeURIComponent(nameMaterial) + "/" + false :
                                    isPieceMaterials ?
                                        '/organization/materials-price-unit-arrival-item/issuance-piece-materials/' + row.original.materialWarehouse?.materialPriceUnit.id + '/' + typeMaterial + '/' + baseUnit + '/' + orderId + '/' + encodeURIComponent(nameOrder) + '/' + materialEstimateUnitId + "/" + encodeURIComponent(nameMaterial) + "/" + false :
                                        '/organization/materials-price-unit-arrival-item/' + row.original.materialWarehouse?.materialPriceUnit.id + '/' + baseUnit + '/' + orderId + '/' + encodeURIComponent(nameOrder) + "/" + materialEstimateUnitId + '/' + estimateId + "/" + estimateState + '/' + encodeURIComponent(nameMaterial) + "/" + encodeURIComponent(articleNumber) + "/" + status + "/" + false + (isEstimate ? `/isEstimate/${orderHeaderId}/${year}/${isIssue}/${type}/${isButtonPurchase}/${isSlab}` : `/${isButtonPurchase}/${isSlab}`)
                    return ["IN_STOCK", "ISSUED", "ARCHIVE"].includes(value) && !isArrival ? <Link
                        to={path}> {materialReserveState[value]}</Link> : materialReserveState[value]

                },
                filterFn: (row, id, filterValue) => {
                    return materialReserveState[row.original.materialReserveState].toLowerCase().includes(filterValue.toLowerCase())
                },
            },
        ];

        if (!isReserveArrival) {
            baseColumns.splice(2, 0, {
                id: 'supplier',
                header: 'Поставщик',
                accessorKey: 'materialWarehouse?.materialPriceUnit.supplierMaterial.supplier.name',
                maxSize: 150,
            });
        }
        if (isColumnMaterialWarehouse) {
            baseColumns.splice(2, 0, {
                id: 'size', header: 'Размеры', accessorKey: 'size', minSize: 15, maxSize: 15,
            });
        }

        if (isIssue) {
            baseColumns.splice(4, 0, {
                id: 'issued',
                header: 'Выдано',
                accessorKey: 'issued',
                minSize: 55,
                maxSize: 55,
                Cell: ({cell, row}) => {
                    const value = cell.getValue();
                    return <Link
                        to={'/organization/issuance-material-reserve/' + row.original.id}>{value === null || value === undefined ? 0 : value.toFixed(3)}</Link>

                },
                Footer: () => (
                    <Stack>
                        <Box color="warning.main">
                            {sumIssued?.toLocaleString?.('en-US', {
                                minimumFractionDigits: 0,
                                maximumFractionDigits: 3,
                            })}
                        </Box>
                    </Stack>
                ),
            });
        }

        if (isPackaging) {
            baseColumns.splice(4, 0, {
                id: 'packaging',
                header: 'Собрано',
                accessorKey: 'packaging',
                size: 8,
                enableEditing: false,
                filterVariant: 'multi-select',
                filterSelectOptions: FilterUtil.statusList,
                Cell: ({cell, row}) => <Checkbox
                    cell={cell}
                    checked={row.original.packaging}
                    onChange={() => handlePackaging(row.original)}
                    sx={{padding: "7px", '& .MuiSvgIcon-root': {fontSize: 22}}}
                ></Checkbox>,
                filterFn: (row, id, filterValue) => {
                    return FilterUtil.checkStatus(row.getValue(id), filterValue)
                },

            });
        }

        if (isIssue) {
            baseColumns.splice(3, 0, {
                id: 'additional',
                header: 'Добавочный',
                accessorKey: 'additional',
                minSize: 55,
                maxSize: 55,
                Cell: ({cell, row}) => <CellCheckbox
                    cell={cell}
                    disabled={true}
                />,
            });
        }

        if (!isIssue && !isReserveArrival) {
            baseColumns.splice(5, 0, {
                id: 'basePrice',
                header: `Цена ${baseCurrency}`,
                accessorKey: 'basePrice',
                minSize: 15,
                maxSize: 15,
                Cell: ({cell, row}) =>
                    <CellMaterialEstimateBasePrice
                        value={cell.getValue()}
                        price={row.original.basePrice}
                        typePrice={row.original.materialReserveTypePrice}
                    />,
            });
        }

        if (!isIssue && !isReserveArrival) {
            baseColumns.splice(6, 0, {
                id: 'alternativePrice',
                header: `Цена ${alternativeCurrency}`,
                accessorKey: 'alternativePrice',
                minSize: 15,
                maxSize: 15,
                Cell: ({cell, row}) =>
                    <CellMaterialEstimateBasePrice
                        value={cell.getValue()}
                        price={row.original.alternativePrice}
                        typePrice={row.original.materialReserveTypePrice}
                    />,
            });
        }

        if (true) {
            baseColumns.splice(7, 0, {
                id: 'amountBasePrice',
                header: `Сумма ${baseCurrency}`,
                accessorKey: 'amountBasePrice',
                minSize: 15,
                maxSize: 15,
                Cell: ({cell, row}) => {
                    const value = cell.getValue();
                    return value === null || value === undefined ? 'Ожидание' : value.toFixed(2)
                },
                Footer: () => (
                    <Stack>
                        <Box color="warning.main">
                            {sumAmountBasePrice?.toLocaleString?.('en-US', {
                                minimumFractionDigits: 0,
                                maximumFractionDigits: 2,
                            })} {baseCurrency}
                        </Box>
                    </Stack>
                ),
            });
        }

        if (true) {
            baseColumns.splice(8, 0, {
                id: 'amountAlternativePrice',
                header: `Сумма ${alternativeCurrency}`,
                accessorKey: 'amountAlternativePrice',
                minSize: 15,
                maxSize: 15,
                Cell: ({cell, row}) => {
                    const value = cell.getValue();
                    return value === null || value === undefined ? 'Ожидание' : value.toFixed(2)
                },
                Footer: () => (
                    <Stack>
                        <Box color="warning.main">
                            {sumAmountAlternativePrice?.toLocaleString?.('en-US', {
                                minimumFractionDigits: 0,
                                maximumFractionDigits: 2,
                            })} {alternativeCurrency}
                        </Box>
                    </Stack>
                ),
            });
        }

        if (!isIssue && !isReserveArrival) {
            baseColumns.splice(9, 0, {
                id: 'materialReserveTypePrice',
                header: 'Тип цены',
                accessorKey: 'materialReserveTypePrice',
                minSize: 55,
                maxSize: 55,
                Cell: ({cell, row}) => <CellMaterialEstimateUnitTypePrice
                    value={cell.getValue()}
                    row={row}
                />,
            });
        }

        if (!isIssue && !isReserveArrival) {
            baseColumns.splice(10, 0, {
                accessorFn: (row) => {
                    if (row.alternativePrice === null) {
                    } else {
                        return new Date(row.alternativePrice.dateTime)
                    }
                },
                id: 'dateBasePrice',
                header: 'Дата цены',
                sortingFn: 'date',
                size: 10,
                Cell: ({cell}) => {
                    if (cell.getValue() !== undefined) {
                        return cell.getValue().toLocaleDateString();
                    }
                },
                filterFn: (row, id, filterValue) => {
                    const startDate = filterValue?.startDate;
                    const endDate = filterValue?.endDate;
                    if (startDate && endDate) {
                        return (
                            DateTimeUtil.checkDateBefore(row.getValue(id), startDate) &&
                            DateTimeUtil.checkDateAfter(row.getValue(id), endDate)
                        );
                    }
                    return true;
                },
                Filter: ({column}) => <DateRangeFilter
                    column={column}
                />,
            });
        }

        if (currentIsSlab) {
            baseColumns.splice(0, 0, {
                id: 'length',
                header: 'Ширина',
                accessorKey: 'materialWarehouse?.materialPriceUnit.length',
                minSize: 15,
                maxSize: 15,
            });
        }

        if (currentIsSlab) {
            baseColumns.splice(1, 0, {
                id: 'width',
                header: 'Высота',
                accessorKey: 'materialWarehouse?.materialPriceUnit.width',
                minSize: 15,
                maxSize: 15,
            });
        }

        if (!allCalculation && !isReserveArrival) {
            baseColumns.splice(3, 0, {
                id: 'availabilityQuantity',
                header: 'Наличие',
                accessorKey: 'availabilityQuantity',
                minSize: 15,
                maxSize: 15,
            });
        }

        if (!allCalculation && !isReserveArrival) {
            baseColumns.splice(4, 0, {
                id: 'orderedQuantity',
                header: 'Заказано',
                accessorKey: 'orderedQuantity',
                minSize: 15,
                maxSize: 15,
            });
        }

        if (!allCalculation && !isReserveArrival) {
            baseColumns.splice(1, 0, {
                id: 'needToOrderQuantity',
                header: 'Необходимо заказать',
                accessorKey: 'needToOrderQuantity',
                minSize: 15,
                maxSize: 15,
            });
        }
        if (isColumnOrder) {
            baseColumns.splice(1, 0, {
                id: 'orders',
                header: 'Заказы',
                accessorKey: 'orders',
                minSize: 400,
                Cell: ({cell}) => {
                    const data = cell.getValue()?.reduce((accumulator, el, i) => accumulator += (i === 0 ? `${el.number}` : `, ${el.number}`), "")
                    return <Tooltip arrow placement="top" title={data}><Box sx={{
                        width: "430px",
                        overflow: "clip",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap"
                    }}>{data}</Box> </Tooltip>
                },
            });
        }
        {
            baseColumns.splice(15, 0, {
                id: 'note',
                header: 'Заметки',
                accessorKey: 'note',
                maxSize: 200,
            });
        }


        return baseColumns;

    }, [data, setData, isSlab]);
    const menuItem = isReserveArrival ? [
            {type: "delete", text: "Удалить закупку", handler: handleDeleteArrival},
            {type: "divide", text: "Разделить резерв", handler: handleDivide},
            {type: "setIssued", text: "Пометить как выданный", handler: setOnIssued},
            {type: "return", text: "Вернуть резерв", handler: setReturn}] :
        isReserveWareHouse ? [
                {type: "delete", text: "Удалить", handler: handleDeleteRow},
                {type: "note", text: "Изменить заметку", handler: handleEditNote},
                {type: "divide", text: "Разделить резерв", handler: handleDivide},
                {type: "setIssued", text: "Пометить как выданный", handler: setOnIssued},
                {type: "return", text: "Вернуть резерв", handler: setReturn}] :
            showSetOnIssue ? [
                {type: "issue", text: "Выдать штучно", handler: setOnIssue},
                {type: "delete", text: "Удалить", handler: handleDeleteRow},
                {type: "note", text: "Изменить заметку", handler: handleEditNote},
                {type: "divide", text: "Разделить резерв", handler: handleDivide},
                {type: "setIssued", text: "Пометить как выданный", handler: setOnIssued},
                {type: "return", text: "Вернуть резерв", handler: setReturn}
            ] : [
                {type: "delete", text: "Удалить", handler: handleDeleteRow},
                {type: "purchase", text: "Отправить на закупку", handler: handleSetPurchase},
                {type: "note", text: "Изменить заметку", handler: handleEditNote},
                {type: "divide", text: "Разделить резерв", handler: handleDivide},
                {type: "setIssued", text: "Пометить как выданный", handler: setOnIssued},
                {type: "return", text: "Вернуть резерв", handler: setReturn}
            ]
    return (
        <Box sx={{maxWidth: isReserveWareHouse ? 2000 : "1500px"}}>
            <Box
                sx={{display: 'flex', justifyContent: "flex-end", paddingBottom: "30px"}}
            >
                {(!isReserveWareHouse && !isReserveArrival) &&
                    <Box sx={{display: 'flex', justifyContent: "spase-between", gap: "9px"}}>
                        <ButtonCreate
                            text={"Добавить резерв"}
                            width={200}
                            onClick={() => setCreateModalOpen(true)}
                        />
                    </Box>}
            </Box>
            <MaterialReactTable
                renderTopToolbar={({table}) => {
                    return <Box sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        padding: "7px",
                        backgroundColor: (theme) => table.getSelectedRowModel().rows.length > 0 ? theme.palette.primary.light : "transparent",
                    }}>
                        <MRT_ToolbarAlertBanner table={table}/>
                        <Box sx={{display: "flex"}}>
                            <MRT_ToggleFiltersButton table={table}/>
                            <MRT_GlobalFilterTextField table={table}/>
                        </Box>
                    </Box>
                }}
                muiToolbarAlertBannerProps={{
                    sx: {
                        backgroundColor: (theme) => theme.palette.primary.light,
                        "& .MuiStack-root": {
                            padding: 0,
                        },
                    }
                }}
                selectAllMode={"all"}
                muiTableBodyCellProps={({cell, table}) => {
                    return ({
                            sx: () => ({
                                    p: cell.column.id === "packaging" ? 0 : '0px 0px 0px 10px',
                                    m: '0px 0px 0px 0px',
                                    border: "none",
                                    textAlign: cell.column.id === "packaging" ? "center" : "left",
                                    "&:after": {
                                        display: "none",
                                    },
                                    "&:not(:last-of-type)": {
                                        borderRight: '1px solid #EAEBEA',

                                    },

                                    "&:first-of-type": {
                                        padding: 0,
                                        width: "50px",
                                        height: "36px",
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        color: (theme) => theme.palette.text.light,
                                        "& .MuiButtonBase-root": {
                                            borderRadius: "4px",
                                            width: "24px",
                                            height: "24px",
                                            opacity: 1,
                                            margin: 0,
                                            padding: 0,
                                            "&:hover": {
                                                backgroundColor: (theme) => theme.palette.primary.stroke,
                                            }
                                        }
                                    },
                                    "& a": {
                                        color: "#006CCC",
                                        textDecoration: "none",
                                        "&:hover": {
                                            textDecoration: "underline"
                                        }
                                    }
                                }
                            )
                        }

                    )
                }}
                muiTableHeadCellProps={{
                    sx: {
                        border: '1px solid #EAEBEA',
                        backgroundColor: "#F5F6FA",
                        padding: "10px",
                        paddingBottom: " 0.2rem",
                        paddingTop: "0.2rem"
                    },
                }}
                muiTableBodyRowProps={({row}) => {
                    return ({
                        sx: () => ({
                            height: '36px',
                            backgroundColor: "white",
                            "&:hover& td:after": {
                                display: "none",
                            },
                            "&.MuiTableRow-root.Mui-selected": {
                                backgroundColor: (theme) => theme.palette.primary.light70,
                                "&:hover": {
                                    backgroundColor: (theme) => theme.palette.primary.light50,
                                },
                            },
                            "&:hover": {
                                "& td:after": {
                                    display: "none",
                                },
                                backgroundColor: (theme) => theme.palette.primary.stroke,
                            },
                            '&:nth-of-type(even)': {
                                "&.MuiTableRow-root.Mui-selected": {
                                    backgroundColor: (theme) => theme.palette.primary.light,
                                    "&:hover": {
                                        backgroundColor: (theme) => theme.palette.primary.light50,
                                    },
                                },
                                backgroundColor: (theme) => theme.palette.primary.lightGrey,
                                "&:hover": {
                                    backgroundColor: (theme) => theme.palette.primary.stroke,
                                },
                            },
                        })
                    })
                }}
                displayColumnDefOptions={{
                    'mrt-row-actions': {
                        header: "",
                        size: 3,
                        minSize: 3,
                        grow: false,
                    },
                    'mrt-row-select': {
                        size: "50px",
                        grow: false,
                    },
                }}
                muiSearchTextFieldProps={{
                    placeholder: `Поиск`,
                    sx: {
                        paddingTop: "5px",
                        paddingBottom: "0px",
                        "& .MuiCollapse-root": {
                            borderRadius: '12px',
                            height: 40, width: 290,
                            "& .MuiSvgIcon-root": {
                                color: "#737478"
                            },
                            '& .MuiOutlinedInput-input': {
                                padding: 0
                            }
                        }
                    },
                    variant: 'outlined',
                }}
                columns={columns}
                data={data}
                rowHeight={13}
                columnSpacing={1}
                getRowId={(originalRow) => originalRow.id}
                onPaginationChange={(updater) => {
                    tableOptionsHandle(updater(tableOptions));
                }}
                onRowSelectionChange={onRowSelectionChange}
                enableRowSelection={enableRowSelection}
                state={{rowSelection: currentSelection, showGlobalFilter: true, pagination: tableOptions,}}
                rowCount={tableOptions.totalElements}
                localization={MRT_Localization_RU}
                enableRowActions={true}
                enableToolbarInternalActions={false}
                enableColumnActions={false}
                muiTableContainerProps={{
                    sx: {
                        maxHeight: rowSelection?.length > 0 ? (isPieceMaterials ? `calc(100vh - 530px)` : `calc(100vh - 610px)`) : (isPieceMaterials ? `calc(100vh - 450px)` : `calc(100vh - 530px)`),
                    }
                }}
                renderRowActionMenuItems={({closeMenu, row}) => menuItem.map(el => {
                    const availableMaterialReserveState = row.original.materialReserveState === 'CALCULATION'
                        || row.original.materialReserveState === 'IN_WORK'
                        || row.original.materialReserveState === 'WAITING_FOR_AN_APPLICATION'
                        || row.original.materialReserveState === 'EXECUTION_OF_APPLICATION'
                        || row.original.materialReserveState === 'IN_STOCK'
                    const availableDivide = row.original.materialReserveState === 'CALCULATION'
                        || row.original.materialReserveState === 'IN_WORK'
                        || row.original.materialReserveState === 'WAITING_FOR_AN_APPLICATION'
                        || row.original.materialReserveState === 'RECONCILIATION_OF_DATA'
                        || row.original.materialReserveState === 'WAITING_FOR_DELIVERY'
                    const available = (el.type === "return" && row.original.materialReserveState === "ISSUED") || (availableDivide && el.type === "divide") || (el.type === "purchase" && status === "CREATED_RESERVES") || (((row.original.quantity === 0 || row.original.quantity !== row.original.issued) && availableMaterialReserveState) && !row.original.workingCuttingMapId && !["setIssued", "return"].includes(el.type)) || (row.original.issued !== 0 && el.type === "setIssued")

                    return <MenuItem
                        key={el.type}
                        disabled={!available}
                        onClick={() => {
                            el.handler(row.original)
                            closeMenu();
                        }}
                        sx={{
                            margin: "0 8px",
                            borderRadius: "4px",
                            opacity: !available && 0.5,
                            "&:hover": {backgroundColor: !available ? "transparent" : (theme) => theme.palette.primary.light}
                        }}
                    >
                        {el.text}
                    </MenuItem>
                })}
            />
            <ModalConfirm
                title={"Пометить как выданный?"}
                modalOpen={issuedModal}
                handleClose={handleCloseSetPurchase}
                handleSubmit={handleSetIssued}
                action={"Подтвердить"}
            />
            <ModalConfirm
                title={"Подтвердить выдачу?"}
                modalOpen={openModal}
                handleClose={handleCloseSetPurchase}
                handleSubmit={handleSubmitSetPurchase}
                action={"Подтвердить"}
            />
            <ModalConfirm
                title={"Вернуть резерв?"}
                modalOpen={returnModal}
                handleClose={handleCloseSetPurchase}
                handleSubmit={handleSubmitReturn}
                action={"Вернуть"}
            />
            {createModalOpen && <CreateSlabMaterialModal
                open={createModalOpen}
                onClose={() => setCreateModalOpen(false)}
                handleCreateNewRow={handleCreateNewRow}
                id={materialEstimateUnitId}
                isSlab={isSlab}
                handleModalAlert={handleModalAlert}
            />}
            <NameModal
                title={modalDivide ? "Введите количество" : "Изменить"}
                type={modalDivide ? "number" : "text"}
                label={modalDivide ? "Количество" : "Наименование"}
                open={modalNote || modalDivide} onClose={handleClose}
                handleSubmit={modalDivide ? divideReserve : handleUpdateNote}
                initValue={modalDivide ? {name: ""} : {name: currentEditRowData?.note}}
                loading={loading}/>
        </Box>);
};

export default ReservationMaterialEstimateUnitTable;